import { tryCatch } from '@libs/core/utils';
import css from './decisions.module.scss';

interface Props {
    data: ReadonlyMap<string, string>;
}
export function Decisions({ data }: Props) {
    const [error, result] = tryCatch(() => JSON.parse(data.get('x-petm-decisions') ?? '{}'));
    const decisions = Object.entries(result ?? {});

    if (error) return <li>Failed to parse cookie</li>;
    if (!decisions.length) return null;

    return (
        <li className={css.wrapper}>
            <span className={css.title}>x-petm-decisions</span>
            <ul className={css.flags}>
                {decisions.map(([flag, value]) => (
                    <li key={flag} className={css.flag}>
                        <span className={css.name}>{flag}</span>
                        <span className={css.value}>{String(value)}</span>
                    </li>
                ))}
            </ul>
        </li>
    );
}
